import { render, staticRenderFns } from "./SplitRuleDetailManage.vue?vue&type=template&id=402e193c&scoped=true"
import script from "./SplitRuleDetailManage.vue?vue&type=script&lang=js"
export * from "./SplitRuleDetailManage.vue?vue&type=script&lang=js"
import style0 from "./SplitRuleDetailManage.vue?vue&type=style&index=0&id=402e193c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402e193c",
  null
  
)

export default component.exports